import ComparerArea from '@/features/comparer/ComparerArea';
import { useImageEnhanceResult } from './useImageEnhanceResult';

export function ImageEnhanceResult({
  isImageSelectorToolbarVisible,
}: {
  isImageSelectorToolbarVisible: boolean;
}) {
  const { isLoading } = useImageEnhanceResult();

  return (
    <ComparerArea
      isLoading={isLoading}
      showTooltip
      className="relative flex-grow transition-transform duration-1000 delay-[3000]"
      hjSuppress
      isImageSelectorToolbarVisible={isImageSelectorToolbarVisible}
      fromId="result"
    />
  );
}
